import React, { useEffect, useState } from "react";
import {
  ArrowDown,
  Calendar,
  Clock,
  Video,
  Check,
  Gift,
  TrendingUp,
} from "lucide-react";

// Set class date here. Defaults to next Tuesday at 19:00 local time if not overridden.
function getDefaultClassDate() {
  const d = new Date();
  d.setDate(d.getDate() + ((2 + 7 - d.getDay()) % 7 || 7)); // next Tuesday
  d.setHours(19, 0, 0, 0);
  return d;
}

const CLASS_DATE = getDefaultClassDate();

function useCountdown(target) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const diff = Math.max(0, target.getTime() - now);
  const d = Math.floor(diff / (1000 * 60 * 60 * 24));
  const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const m = Math.floor((diff / (1000 * 60)) % 60);
  const s = Math.floor((diff / 1000) % 60);
  return { d, h, m, s };
}

const STACK = [
  {
    name: "Curso completo Ventas Virales",
    sub: "6 sesiones en directo conmigo + Judit Contreras + equipo Climbuu",
    value: "1.997€",
    main: true,
  },
  {
    name: "Curso Optimiza tu bio para vender más",
    value: "297€",
  },
  {
    name: "Curso Planifica tu calendario editorial",
    value: "297€",
  },
  {
    name: "Curso Métricas para crecer en redes",
    value: "297€",
  },
  {
    name: "Curso Ads para más seguidores",
    value: "297€",
  },
  {
    name: "Curso Herramientas digitales",
    sub: "CapCut, ManyChat, IA y más",
    value: "497€",
  },
  {
    name: "Masterclass Maestros",
    sub: "6 directos con figuras top del sector",
    value: "997€",
  },
  {
    name: 'Programa “Te Acompaño”',
    sub: "Mi equipo contigo cada semana",
    value: "1.997€",
  },
  {
    name: "GPTs personalizados de guiones",
    value: "997€",
  },
  {
    name: "Mega Bundle Biz’s Cool",
    sub: "34 formaciones extra",
    value: "7.595€",
  },
];

export default function Hero() {
  const scrollToForm = (e) => {
    e.preventDefault();
    const el = document.getElementById("formulario");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const { d, h, m, s } = useCountdown(CLASS_DATE);

  const dateStr = CLASS_DATE.toLocaleDateString("es-ES", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
  const timeStr = CLASS_DATE.toLocaleTimeString("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <section
      className="hero"
      style={{ minHeight: "auto", paddingBottom: "3rem" }}
    >
      <div className="hero-bg" />
      <div
        className="container fade-in"
        style={{ position: "relative", zIndex: 1, textAlign: "center" }}
      >
        <div className="eyebrow-yellow" style={{ marginBottom: "1rem" }}>
          ✨ Masterclass en directo · 1ª clase del programa Ventas Virales
        </div>

        <h1 className="h1-hero">
          Deja de ser <span className="serif-italic hl-purple">invisible</span>.
          <br />
          Empieza a <span className="hl-yellow serif-italic">vender</span>
          <br />
          desde tus redes.
        </h1>

        <p
          style={{
            maxWidth: 760,
            margin: "1.6rem auto 1.4rem",
            color: "var(--text-dim)",
            fontSize: "1.08rem",
            lineHeight: 1.7,
          }}
        >
          Soy <strong style={{ color: "#fff" }}>Judit Català</strong>. En los
          últimos meses he pasado de 100.000 a más de{" "}
          <strong style={{ color: "#fff" }}>950.000 seguidores en 5 meses</strong>{" "}
          aplicando el mismo método que voy a enseñarte. En esta primera clase de
          <strong style={{ color: "#fff" }}> Ventas Virales</strong> te muestro,
          paso a paso y sin filtros, cómo convertir tu contenido en clientes.
          Si te gusta lo que vives en la clase, podrás entrar al programa con
          todo lo que ves justo debajo.
        </p>

        {/* Social proof badge */}
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            background: "rgba(155,111,255,0.10)",
            border: "1px solid rgba(155,111,255,0.4)",
            color: "#d8c9ff",
            padding: "0.45rem 0.95rem",
            borderRadius: 999,
            fontSize: "0.82rem",
            fontWeight: 600,
            letterSpacing: "0.04em",
            marginBottom: "1.6rem",
          }}
        >
          <TrendingUp size={14} color="#b59bff" />
          <span>
            <span style={{ color: "#fff" }}>+850.000 seguidores</span> en solo
            5 meses con este sistema
          </span>
        </div>

        {/* Event meta */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "1.5rem",
            flexWrap: "wrap",
            color: "var(--text-dim)",
            marginBottom: "1.5rem",
            fontSize: "0.92rem",
          }}
        >
          <span
            style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
          >
            <Calendar size={16} color="#d9ff00" />
            <span style={{ textTransform: "capitalize" }}>{dateStr}</span>
          </span>
          <span
            style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
          >
            <Clock size={16} color="#d9ff00" /> {timeStr} h (hora España)
          </span>
          <span
            style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
          >
            <Video size={16} color="#d9ff00" /> En directo online
          </span>
        </div>

        <button
          onClick={scrollToForm}
          className="btn-neon"
          data-testid="hero-cta"
        >
          Reservar mi plaza en la clase <ArrowDown size={18} />
        </button>

        {/* Countdown */}
        <div className="stats-row" aria-label="Cuenta atrás">
          <div className="stat-cell">
            <div className="stat-num accent">{String(d).padStart(2, "0")}</div>
            <div className="stat-label">Días</div>
          </div>
          <div className="stat-cell">
            <div className="stat-num">{String(h).padStart(2, "0")}</div>
            <div className="stat-label">Horas</div>
          </div>
          <div className="stat-cell">
            <div className="stat-num accent">{String(m).padStart(2, "0")}</div>
            <div className="stat-label">Minutos</div>
          </div>
          <div className="stat-cell">
            <div className="stat-num">{String(s).padStart(2, "0")}</div>
            <div className="stat-label">Segundos</div>
          </div>
        </div>

        {/* Stack of the offer */}
        <div
          style={{
            marginTop: "3.5rem",
            background:
              "linear-gradient(180deg, rgba(155,111,255,0.07) 0%, rgba(217,255,0,0.04) 100%)",
            border: "1px solid rgba(155,111,255,0.25)",
            borderRadius: 22,
            padding: "2.2rem",
            maxWidth: 920,
            marginLeft: "auto",
            marginRight: "auto",
            textAlign: "left",
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              background: "rgba(217,255,0,0.10)",
              border: "1px solid rgba(217,255,0,0.4)",
              padding: "0.4rem 0.9rem",
              borderRadius: 999,
              color: "var(--neon)",
              fontWeight: 700,
              letterSpacing: "0.18em",
              fontSize: "0.7rem",
              textTransform: "uppercase",
              marginBottom: "0.9rem",
            }}
          >
            <Gift size={14} /> Esto te llevas si entras a Ventas Virales
          </div>
          <h3
            className="h3-block"
            style={{
              fontSize: "1.6rem",
              marginBottom: "1.3rem",
              color: "#fff",
              lineHeight: 1.2,
            }}
          >
            Todo lo que recibes dentro del{" "}
            <span className="serif-italic hl-purple">programa</span>.
          </h3>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
              display: "grid",
              gridTemplateColumns: "1fr",
              gap: "0",
            }}
          >
            {STACK.map((it, idx) => (
              <li
                key={idx}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  gap: "1rem",
                  padding: "0.95rem 0.4rem",
                  borderBottom:
                    idx === STACK.length - 1
                      ? "none"
                      : "1px dashed rgba(255,255,255,0.08)",
                  background: it.main
                    ? "linear-gradient(90deg, rgba(217,255,0,0.06), transparent)"
                    : "transparent",
                  borderRadius: it.main ? 12 : 0,
                  paddingLeft: it.main ? "0.9rem" : "0.4rem",
                  paddingRight: it.main ? "0.9rem" : "0.4rem",
                  marginBottom: it.main ? "0.4rem" : 0,
                }}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "0.7rem",
                    color: "#e8e8e8",
                    fontSize: "0.98rem",
                  }}
                >
                  <span
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: 999,
                      background: it.main
                        ? "var(--neon)"
                        : "rgba(217,255,0,0.12)",
                      border: it.main
                        ? "none"
                        : "1px solid rgba(217,255,0,0.45)",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flex: "0 0 auto",
                      marginTop: 2,
                    }}
                  >
                    <Check
                      size={13}
                      color={it.main ? "#0a0a0a" : "#d9ff00"}
                      strokeWidth={3}
                    />
                  </span>
                  <span style={{ display: "flex", flexDirection: "column" }}>
                    <span
                      style={{
                        fontWeight: it.main ? 700 : 500,
                        color: it.main ? "#fff" : "#e8e8e8",
                        lineHeight: 1.35,
                      }}
                    >
                      {it.main ? null : (
                        <span
                          style={{ color: "var(--neon)", marginRight: 6 }}
                        >
                          ⚡
                        </span>
                      )}
                      {it.name}
                    </span>
                    {it.sub && (
                      <span
                        style={{
                          color: "#999",
                          fontSize: "0.84rem",
                          marginTop: 2,
                          lineHeight: 1.4,
                        }}
                      >
                        {it.sub}
                      </span>
                    )}
                  </span>
                </span>
                <span
                  style={{
                    fontFamily: "'Playfair Display', serif",
                    fontWeight: 800,
                    color: "var(--neon)",
                    whiteSpace: "nowrap",
                    fontSize: "1.1rem",
                    marginTop: 2,
                  }}
                >
                  {it.value}
                </span>
              </li>
            ))}
          </ul>
          <div
            style={{
              marginTop: "1.4rem",
              paddingTop: "1.2rem",
              borderTop: "1px solid rgba(255,255,255,0.12)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "baseline",
              flexWrap: "wrap",
              gap: "0.6rem",
            }}
          >
            <span
              style={{
                color: "#fff",
                fontSize: "1rem",
                fontWeight: 700,
                letterSpacing: "0.04em",
              }}
            >
              💰 VALOR TOTAL
            </span>
            <span
              className="serif-italic"
              style={{
                color: "var(--neon)",
                fontFamily: "'Playfair Display', serif",
                fontWeight: 800,
                fontSize: "2rem",
                lineHeight: 1,
              }}
            >
              15.268€
            </span>
          </div>
          <p
            style={{
              color: "#888",
              fontSize: "0.86rem",
              marginTop: "0.9rem",
              marginBottom: 0,
              textAlign: "center",
            }}
          >
            Reserva tu plaza en la clase y descubre cómo entrar al programa con
            condiciones únicas para asistentes.
          </p>
        </div>
      </div>
    </section>
  );
}
